<template>
  <page>
    <template v-slot:content>
      <v-container fluid :fill-height="loading">
        <v-dialog
          v-if="dialogs.delete"
          v-model="dialogs.delete"
          max-width="300"
        >
          <action-form
            item="company"
            v-on:close="dialogs.delete = false"
            v-on:remove="remove"
          ></action-form>
        </v-dialog>
        <v-dialog v-if="dialogs.clear" v-model="dialogs.clear" max-width="300">
          <action-form
            item="company"
            action="clear"
            v-on:close="dialogs.clear = false"
            v-on:remove="clear"
          ></action-form>
        </v-dialog>
        <v-dialog
          v-if="dialogs.clearLocation"
          v-model="dialogs.clearLocation"
          max-width="300"
        >
          <action-form
            item="location"
            action="clear"
            v-on:close="dialogs.clearLocation = false"
            v-on:remove="clearLoc"
          ></action-form>
        </v-dialog>
        <v-dialog
          v-if="dialogs.clearItems"
          v-model="dialogs.clearItems"
          max-width="300"
        >
          <action-form
            :item="statItem.name"
            action="clear"
            v-on:close="dialogs.clearItems = false"
            v-on:remove="clearItems"
          ></action-form>
        </v-dialog>
        <v-row align="center" justify="center" fill-height class="pt-3">
          <v-progress-circular
            :size="70"
            :width="7"
            color="secondary"
            indeterminate
            v-if="loading"
          ></v-progress-circular>
        </v-row>
        <v-card v-if="company !== null && !loading">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-toolbar text color="white">
                  <div>
                    <div class="display-1 font-weight-medium">
                      {{ company.name }}
                    </div>
                    <h3>{{ company._id }}</h3>
                  </div>
                  <v-spacer></v-spacer>
                  <v-toolbar-items v-if="!mobile">
                    <v-tooltip bottom color="blue">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" color="blue" dark @click="view">
                          <font-awesome-icon icon="sign-in-alt" size="lg" />
                        </v-btn>
                      </template>
                      <span>Login</span>
                    </v-tooltip>
                    <v-tooltip bottom color="orange">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="orange"
                          dark
                          @click="dialogs.clear = true"
                        >
                          <font-awesome-icon icon="redo" size="lg" />
                        </v-btn>
                      </template>
                      <span>Clear</span>
                    </v-tooltip>

                    <v-tooltip bottom color="red">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="usercompany._id != company._id"
                          v-on="on"
                          color="red"
                          dark
                          @click="dialogs.delete = true"
                        >
                          <font-awesome-icon icon="trash" size="lg" />
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </v-toolbar-items>
                  <v-toolbar-items v-if="mobile">
                    <v-menu offset-y bottom transition="slide-y-transition">
                      <v-btn text slot="activator" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile @click="view()">
                          <v-list-tile-action>
                            <v-icon color="black">link</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>Login</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="dialogs.clear">
                          <v-list-tile-action>
                            <v-icon color="black">clear</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>Clear</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-if="usercompany._id != company._id"
                          text
                          @click="dialogs.delete = true"
                        >
                          <v-list-tile-action>
                            <v-icon color="black">delete</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>Delete</v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
            </v-row>
            <v-divider></v-divider>

            <v-row row justify="center">
              <v-col cols="12" sm="8" md="6" lg="4">
                <v-text-field
                  :type="showAPIKey ? 'text' : 'password'"
                  filled
                  :value="apiKey"
                  label="API KEY"
                  hide-details
                  readonly
                  outlined
                >
                  <template v-slot:append>
                    <font-awesome-icon
                      :icon="showAPIKey ? 'eye' : 'eye-slash'"
                      size="lg"
                      @click="fetchAPIKey()"
                    />
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row>
              <v-col cols="12" sm="6">
                <v-subheader>Locations</v-subheader>
                <v-card
                  class="pa-2 ma-1"
                  v-for="location in locations"
                  :key="location._id"
                >
                  <v-row dense>
                    <v-col cols="auto">
                      <h2>{{ location.name }}</h2>
                      <h3>{{ location._id }}</h3>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <v-tooltip bottom color="orange">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="orange"
                            dark
                            @click="
                              (loc = location), (dialogs.clearLocation = true)
                            "
                          >
                            <font-awesome-icon icon="times" size="lg" />
                          </v-btn>
                        </template>
                        <span>Clear Location</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <div v-for="(stat, index) in location.stats" :key="index">
                    <v-divider></v-divider>
                    <div
                      class="pa-2"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                    >
                      <div>
                        <div class="subheading">{{ stat.name }}</div>
                        <div class="caption">
                          last updated:
                          <span v-if="stat.lastUpdated">
                            {{ moment(stat.lastUpdated.updatedAt).calendar() }}
                          </span>
                        </div>
                      </div>

                      <div>
                        <span class="subheading font-weight-medium">{{
                          stat.count
                        }}</span>

                        <font-awesome-icon
                          icon="times-circle"
                          size="lg"
                          class="ml-2"
                          @click="
                            (loc = location),
                              (statItem = stat),
                              (dialogs.clearItems = true)
                          "
                          :style="{ color: 'red' }"
                        />
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <v-subheader>Users</v-subheader>
                <v-card class="pa-2" v-for="user in users" :key="user._id">
                  <h2>{{ user.firstName }} {{ user.lastName }}</h2>
                  <div>{{ user.email }}</div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-container>
    </template>
  </page>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      apiKey: "***************************",
      showAPIKey: false,

      dialogs: {
        delete: false,
        clear: false,
        clearLocation: false,
        clearItems: false,
      },
      company: null,
      users: null,
      employees: null,
      locations: null,
      loc: null,
      statItem: null,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      admin: (state) => state.admin,
    }),
    usercompany() {
      return this.account.company;
    },
    loading() {
      return this.admin.loading;
    },
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
  },
  methods: {
    ...mapActions({
      fetchCompany: "admin/fetchCompany",
      deleteCompany: "admin/deleteCompany",
      clearCompany: "admin/clearCompany",
      clearLocation: "admin/clearLocation",
      clearItemTypes: "admin/clearItems",
      setAdminCompany: "account/setAdminCompany",
      getApiKey: "account/getApiKey",
    }),
    remove() {
      this.dialogs.delete = false;
      this.deleteCompany(this.company._id).then((resp) => {
        console.log(resp);
        this.$router.push("/admin");
      });
    },
    clear() {
      this.dialogs.clear = false;
      this.clearCompany(this.company._id).then((resp) => {
        console.log(resp);
        this.$router.push("/admin");
      });
    },
    clearLoc() {
      this.dialogs.clearLocation = false;
      this.clearLocation({
        company: this.company._id,
        location: this.loc._id,
      }).then((resp) => {
        console.log(resp);
        this.$router.push("/admin");
      });
    },

    clearItems() {
      this.dialogs.clearItems = false;
      this.clearItemTypes({
        company: this.company._id,
        location: this.loc._id,
        type: this.statItem.name,
      }).then((resp) => {
        console.log(resp);
        this.statItem.count = 0;
      });
    },
    view() {
      this.setAdminCompany({
        company: this.company,
        locations: this.locations,
      });
      // this.$tabs.reset("/");
      this.$router.push("/");
    },
    fetchAPIKey() {
      if (this.showAPIKey) {
        this.showAPIKey = false;
        this.apiKey = "***************************";
      } else {
        this.getApiKey().then((key) => {
          this.apiKey = key;
          this.showAPIKey = true;
        });
      }
    },
  },
  mounted() {
    this.fetchCompany(this.$route.params.id).then((resp) => {
      console.log(resp);
      this.company = resp.company;
      this.locations = resp.locations;
      this.users = resp.users;
    });
  },
};
</script>
